import { Observable } from "rxjs";
import { BaseResponseModel } from "../models/base-response.model";
import { InjectionToken } from "@angular/core";
import { HeaderCountsModel, NotificationSearchModel, NrSearchModel } from "../models";

export const COMMON_SERVICE = new InjectionToken("common service...")
export interface CommonInterface {

    notificationCount$: Observable<number>;
    setNotificationCount(count: number): void;

    // changeFormatUtcToIst<T>(formateData: BaseResponseModel<T>): any[];

    getInwardCountData(): Observable<BaseResponseModel<HeaderCountsModel>>;

    getNotificationList(searchModel: NotificationSearchModel): Observable<BaseResponseModel<any>>;

    notificationMarkAsRead(nrSearchModel: NrSearchModel): Observable<BaseResponseModel<any>>;

    getStoreList(): Observable<BaseResponseModel<any>>;

    getInvoiceList(MaterialTypeId:number,IsReceived:boolean,IsSNMCC:boolean): Observable<BaseResponseModel<any>>;

    getNotificationsUnreadCount(): Observable<BaseResponseModel<any>>;

    sendOtp(mobileNo: string, purpose: string): Observable<BaseResponseModel<any>>;

    verifyOtp(id: string, otp: string): Observable<BaseResponseModel<any>>;

}